import { Component } from 'react'
import moment from 'moment'
import { updateJobApply } from '../../../../../insfrastructure/services/job-applies'
import Modal from '../../../../components/modal'
import { SubmitBtn } from '../../../../components/submit'
import { Input } from '../../../../components/input'
import calendarIcon from '../../../../../assets/icons/calendar-blue.png'
import './styles.sass'
import { emptyField, ErrorMessage, errorsLength, formatErrors } from '../../../../../insfrastructure/utils/form-validators'
import ResponseModal from '../../../../components/response-modal'

interface ModalProps {
    render: boolean,
    candidate: any,
    jobapply_id: any,
    onClose: () => void,
    onSubmitted: () => void
}

export default class IntervalModal extends Component<ModalProps> {
    state: any = {
        form: {},
        formErrors: {},
        loading: false
    }

    componentDidUpdate(prevProps: Readonly<ModalProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps.render !== this.props.render) {
            this.setState({ 
                form: {},
                formErrors: {},
                loading: false
            });    
        };
    }

    onSubmit = async () => {
        if(this.state.loading) return;

        const errors = formatErrors({
            interview_date: [emptyField(this.state.form.interview_date)]
        });

        this.setState({ formErrors: errors });

        if(errorsLength(errors) > 0) return;

        try {
            this.setState({ loading: true });
            
            await updateJobApply(this.props.jobapply_id, {
                status: 'interview',
                interview_date: moment(this.state.form.interview_date).format('YYYY-MM-DD HH:mm:ss')
            });

            setTimeout(() => {
                let responseData = {
                    type: 'success',
                    title: 'Convite enviado com sucesso!'
                };
            
                this.setState({ loading: false, responseData });
            }, 500);
        } catch (error) {};
    }

    render() {
        return (
            <>
                <Modal render={this.props.render && !this.state.responseData} onClose={() => this.props.onClose()}>
                    <div className='interview-modal'>
                        <div className='modal-header'>
                            <img src={calendarIcon} alt='calendar-icon' />
                            <h4>Chamar <b>{this.props.candidate?.full_name}</b> para uma entrevista</h4>
                        </div>
                        <form>
                            {/* <div className='contact-selector'>
                                <label>Selecione um contato:</label>
                                <span 
                                className={'contact '+(this.state.form.contact === 'mail' ? 'selected' : '')}
                                onClick={() => this.setState({ form: { ...this.state.form, contact: 'mail' } })}>
                                    {this.props.candidate?.email}
                                    <img src={mailIcon} alt='mail-icon' />
                                </span>
                                <span 
                                className={'contact '+(this.state.form.contact === 'phone' ? 'selected' : '')}
                                onClick={() => this.setState({ form: { ...this.state.form, contact: 'phone' } })}>
                                    {this.props.candidate?.phone}
                                    <img src={whatsappIcon}  alt='whatsapp-icon'/>
                                </span>
                            </div> */}
                            <Input
                            name='interview_date'
                            label='Data e Hora:'
                            showTimeSelect={true}
                            type='date'
                            value={this.state.form.interview_date}
                            dateFormat='dd/MM/YYYY HH:mm'
                            onChange={(e) => {
                                this.setState({ form: { ...this.state.form, interview_date: e }});
                            }}/>
                            <ErrorMessage errors={this.state.formErrors['interview_date']} />
                        </form>
                        <SubmitBtn
                        className='primary'
                        text='Agendar entrevista'
                        loadingText='Agendando entrevista...'
                        onSubmit={this.onSubmit}
                        loading={this.state.loading} />
                    </div>
                </Modal>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => {
                    this.setState({ responseData: null });
                    this.props.onSubmitted();
                }} />
            </>
        )
    }
}
